export function isValidEmail(email) {
  const s = String(email || "").trim();
  if (!s) return false;
  // Reasonable, non-overstrict email check (works for most real emails).
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(s);
}
